import React, { useRef, useState } from 'react';
import CompGridMatchmaking from '@components/grid/comp-grid-matchmaking.js';
import CompFormMatchmaking from '@components/form/comp-form-matchmaking.js';
import CompFormMatchmakingState from '@components/form/comp-form-matchmaking-state.js';
import CompFormtrmntBracket from '@components/form/comp-form-trmntBracket.js';
import SearchForm from '@components/form/fragment/comp-fmt-search.js';
import ButtonForm from '@components/form/fragment/comp-fmt-button.js';
import {removeGrid, ApiSave} from '@assets/js/api/commonApi.js';

const MatchmakingMng = (props) => {
    /****************************
     * Define required variables
    *****************************/
    const childRef = useRef();
    const childGridRef = useRef();
    const childStateRef = useRef();
    const childBracketRef = useRef();
    const [params, setParams] = useState({});
    const [selectedRows, setSelectedRows] = useState({ ids: [], data: [] });

    /**************************
     * Define button functions
    ***************************/
    const onNew = () => {
        childRef.current.modalToggle({mode: 'I'});
    }
    const onModify = (params, field) => {
        if (field === 'mtmkgNm') {
            childRef.current.modalToggle({mode: 'M', ...params});

        } else if (field === 'plyrLCnt' || field === 'plyrRCnt') {
            //토너먼트 대진표 생성.
            generateTournamentBracket(params, field);
        }
    }
    const onRemove = () => {
        if (selectedRows.length === 0) { alert('1건이상 선택해주세요.'); return; }
        const idsArray = [...selectedRows.ids];
        if (idsArray.length === 0) {
            alert('삭제할 항목을 선택해주세요.');
            return;
        }

        const deleteParams = {
            deleteList: idsArray.map(rowId => {
                // MTMKG_CD format: 대회코드-부문코드-체급코드
                return {
                    mtmkgCd: rowId,
                };
            })
        };
        
        removeGrid('/sys/mtmkgmng/remove/info', deleteParams, {
            msg: {
                confirm: '선택된 ' + idsArray.length + '개 항목을 삭제하시겠습니까?',
            }
        }).then(res => {
            if (res && res.success) {
                //clear selected rows grid.
                setSelectedRows(new Set());
                onGridSearch();
            }
        });
    }
    //토너먼트 생성(선수별 bracket 랜덤 생성)
    const onMatchTrmntRegister = () => {
        if (!selectedRows || !selectedRows.data || selectedRows.data.length === 0) {
            alert('1건이상 선택해주세요.');
            return;
        }
        
        //대기 상태의 데이터인지 확인.
        let isNotReadyCnt = 0;
        let useNoCnt = 0;
        let trmntChk = {
            trmntUseBelowPlyrArr: [],
            trmntUsePlyrArr: []
        }
        selectedRows.data.forEach((item) => {
            if (item.mtmkgStat !== 'R') {  //R: 대기, C: 확정, D: 진행, E: 종료
                isNotReadyCnt++;
            }
            if (item.useYn === 'N') {
                useNoCnt++;
            }
            if (item.plyrLCnt <= 2 || item.plyrRCnt <= 2) {
                trmntChk.trmntUseBelowPlyrArr.push(item.comptnNm);
            }
            if (item.plyrLCnt > 32 || item.plyrRCnt > 32) {
                trmntChk.trmntUsePlyrArr.push(item.comptnNm);
            }
        });
        if (useNoCnt > 0) {
            alert("사용여부가 '사용' 상태의 데이터만 선택해주세요.");
            return;
        }
        if (isNotReadyCnt > 0) {
            alert("대진 상태가 '대기' 상태의 데이터만 선택해주세요.");
            return;
        }

        if (trmntChk.trmntUseBelowPlyrArr.length > 0) {
            alert(`2명 이하인 대진의 토너먼트는 생성되지 않습니다.\n(${trmntChk.trmntUseBelowPlyrArr.join(' ,')})`);
        }
        if (trmntChk.trmntUsePlyrArr.length > 0) {
            alert(`32명을 초과하는 대진의 토너먼트는 생성되지 않습니다.\n(${trmntChk.trmntUsePlyrArr.join(' ,')})`);
        }

        const opt = {
            msg : {
                confirm: '선택된 ' + selectedRows.data.length + '건의 토너먼트를 생성 하시겠습니까? \n[선수별 시드는 랜덤 배정됩니다]',
                message: '토너먼트 생성이 완료 되었습니다.',
            },
        }
        const params = {
            registerList: selectedRows.data,
        };

        ApiSave('/sys/mtmkgmng/gen/plyr', params, opt).then(res => {
            if (res && res.success) {
                //clear selected rows grid.
                setSelectedRows({ ids: new Set(), data: [] });
                onGridSearch();
            }
        });
    }
    //대진상태 변경 폼 호출.
    const onChangeState = () => {
        if (!selectedRows || !selectedRows.data || selectedRows.data.length === 0) {
            alert('1건이상 선택해주세요.');
            return;
        }

        //대회명 추출.
        let competitionNmArr = [];
        let competitionTypeCnt = 0
        let competitionType = '';
        selectedRows.data.forEach((item, idx) => {
            if (!competitionNmArr.includes(item.comptnNm)) {
                competitionNmArr.push(item.comptnNm);
            }

            if (competitionType !== item.mtmkgTycd) {
                competitionType = item.mtmkgTycd;
                competitionTypeCnt++;
            }
        });

        if (competitionTypeCnt > 1) {
            alert('여러종류의 대진타입(더블, 싱글)을 선택할 수 없습니다.');
            return;
        }

        const dataList = [...selectedRows.data];

        childStateRef.current.modalToggle({updateList: dataList, comptnNm: competitionNmArr.join(', ')});
    }
    //토너먼트 대진표 열기
    const generateTournamentBracket = (rowData, field) => {
        if (rowData[field] <= 2) {
            alert('3명이상의 참가자가 필요합니다.')
            return;
        }

        if (rowData[field] > 32) {
            alert('32명이 초과하는 토너먼트는 지원하지 않습니다.');
            return;
        }

        // 팔 타입 결정 (field가 plyrLCnt면 왼팔, plyrRCnt면 오른팔)
        const armType = field === 'plyrLCnt' ? 'L' : 'R';

        // 대진표 팝업 열기
        childBracketRef.current.modalToggle({
            mtmkgCd: rowData.mtmkgCd,
            armType: armType,
            mtmkgTycd: rowData.mtmkgTycd || 'D',
            mtmkgStat: rowData.mtmkgStat || 'R',
            comptnNm: rowData.comptnNm,
            mtmkgNm: rowData.mtmkgNm
        });
    }

    const onGridSearch = () => {
        childGridRef.current.onGridSearch(params);
    }
    const onValChange = (e) => {
        const { id, value } = e.target;
        // Update the state with the new value
        setParams({ ...params, [id]: value });
    }

    /****************************
     * Define form config
    *****************************/
    const formObj = {
        id : 'searchForm',
        params : {
            comptnNm : {
                id: 'comptnNm',
                label: '대회',
                maxLength : 100,
            },
            mtmkgNm : {
                id : 'mtmkgNm',
                label : '대진명',
                maxLength : 10,
                // newLine : true
            },
            mtmkgStat : {
                id: 'mtmkgStat', 
                label: '대진상태', 
                type: 'selectbox', 
                grpCd: 'GRP007', 
            },
            useYn : {
                id: 'useYn', 
                label: '사용여부', 
                type: 'selectbox', 
                grpCd: 'GRP001', 
            },
        }
    }
    const buttonConfig = {
        fncButtons: [
            { id: 'changeState', label: '대진 상태변경', className: 'btn-success', onClick: onChangeState },
            { id: 'trmntGenerate', label: '토너먼트생성', className: 'btn-primary', onClick: onMatchTrmntRegister },
        ],
        leftButtons: [
            { id: 'new', label: 'New', className: 'btn-success', onClick: onNew },
            { id: 'remove', label: 'Remove', className: 'btn-danger', onClick: onRemove }
        ],
        rightButtons: [
            { id: 'search', label: 'Search', className: 'btn-primary', onClick: onGridSearch }
        ]
    }

    return (
        <>
            {/* SearchForm */}
            <SearchForm formObj={formObj} onValChange={onValChange} onGridSearch={onGridSearch} params={params}/>

            {/* ButtonForm */}
            <ButtonForm buttonConfig={buttonConfig} />

            {/* Grid */}
            <CompGridMatchmaking ref={childGridRef} onChildClick={onModify} onSelectionChange={setSelectedRows} />

            {/* Modal popup */}
            <CompFormMatchmaking ref={childRef} onGridSearch={onGridSearch} />

            {/* State change modal popup */}
            <CompFormMatchmakingState ref={childStateRef} onGridSearch={onGridSearch} />

            {/* Tournament bracket modal popup */}
            <CompFormtrmntBracket ref={childBracketRef} onGridSearch={onGridSearch} />
        </>
    );
}

export default MatchmakingMng;